import React from "react";
import { Badge } from "../ui/badge";

interface VersionBadgeProps {
  version?: string;
  hasUnpublishedChanges?: boolean;
}

/**
 * Simple badge to display version for agents or agent actions
 * Shows the version number and optionally an indicator for unpublished changes
 */
export const VersionBadge: React.FC<VersionBadgeProps> = ({
  version,
  hasUnpublishedChanges = false,
}) => {
  if (!version && !hasUnpublishedChanges) {
    return null;
  }

  return (
    <div className="inline-flex items-center gap-1.5">
      {hasUnpublishedChanges ? (
        <Badge 
          variant="secondary"
          title="Has unpublished changes"
        >
          Draft
        </Badge>
      ) : version ? (
        <Badge variant="outline" className="font-mono">
          v{version}
        </Badge>
      ) : null}
    </div>
  );
};